export const routes = {
    transactions: '/',
    consumers: '/consumers',
    admins: '/admins',
    admin: '/admins/:id',
    consumer: '/consumers/:id',
    logs: '/logs',
    tickets: '/tickets',
    signin: '/sign-in',
    forgot: '/forgot-password',
    not_found: '/404',
    loyalty: '/loyalty',
    limits: '/limits',
    signup: '/sign-up',
    agreements: '/agreements',
    agreement: '/agreements/:id',
    products: '/products',
    external_payments: '/external-payments',
    gift_cards: '/gift-cards',
    funds_flow: '/funds-flow',
    aml_alerts: '/aml/alerts',
    aml_alert: '/aml/alerts/:id',
    aml_cases: '/aml/cases',
    aml_case: '/aml/cases/:id',
    aml_settings: '/aml/settings',
    eps_settings: '/eps/settings'
};
